import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { UtensilsIcon, UsersIcon, MapPinIcon, TrophyIcon } from 'lucide-react';
const features = [{
  icon: UtensilsIcon,
  title: 'Authentic Cuisine',
  description: 'Traditional recipes with modern presentation'
}, {
  icon: UsersIcon,
  title: 'Expert Team',
  description: 'Passionate professionals dedicated to service'
}, {
  icon: MapPinIcon,
  title: 'Prime Locations',
  description: 'Strategically positioned across Thailand'
}, {
  icon: TrophyIcon,
  title: 'Award Winning',
  description: 'Recognized for culinary excellence'
}];
export function Story() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-214">
      <div className="max-w-7xl mx-auto" data-id="element-215">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-216">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-217">
            <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-218">
              Our Story
            </span>
            <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-8 leading-tight" data-id="element-219">
              About BV Group Hospitality
            </h2>
            <div className="w-16 h-[1px] bg-[#c9a961] mb-8" data-id="element-220" />
            <p className="text-[#86868b] text-[18px] leading-relaxed mb-6 font-light" data-id="element-221">
              BV Group Hospitality is a premier hospitality management company
              with a diverse portfolio of restaurants, entertainment venues, and
              hospitality services across Thailand.
            </p>
            <p className="text-[#86868b] text-[18px] leading-relaxed font-light" data-id="element-222">
              With 16 properties across 10 brands, we pride ourselves on
              authentic flavors, impeccable service, and creating memorable
              moments. Coming soon: 4-star hotels in Thailand.
            </p>
          </motion.div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-6" data-id="element-223">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="p-8 bg-[#faf8f5] border border-[#f0ebe3] hover:border-[#c9a961]/30 transition-colors duration-300" data-id="element-224">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm text-[#c9a961]" data-id="element-225">
                  <feature.icon className="w-6 h-6" data-id="element-226" />
                </div>
                <h3 className="font-display text-[#1d1d1f] font-medium text-[20px] mb-2" data-id="element-227">
                  {feature.title}
                </h3>
                <p className="text-[#86868b] text-[14px] leading-relaxed" data-id="element-228">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}